import {Log} from '@aboutyou/mlm';
import {getIsDatadogInfoLogsConsentGiven} from '@aboutyou/storage';
import {useCallback} from 'react';

interface AbTestEvent {
  event: 'activation';
  attributes: {
    user_id?: string;
    ab_test_key: string;
    ab_test_group: string;
  };
}

/**
 * AB test events are unsampled so that exposure numbers can be compared against
 * the App, which reports the same flat schema.
 */
export const useAbTestLogger = () => {
  const logAbTestEvent = useCallback(({event, attributes}: AbTestEvent) => {
    if (!getIsDatadogInfoLogsConsentGiven()) return;

    Log.unSampledLog(`ab-testing ${event}`, {
      feature: 'ab_tests',
      event,
      ...attributes,
    });
  }, []);

  return {logAbTestEvent};
};
